module.exports = __webpack_public_path__ + "media/customizations/cypressgreenlife/logo-new-3b19575b53bde42927cc7ab186f97a08.png";